import { getAggregationReports, getConversationReports, getDetailedReports, getPointReports } from "../../api/report";

const report = {
    namespaced: true,
    state: {
        reports: {
            conversation: [],
            aggregation: [],
            detailed: [],
            points: [],
        },
    },
    mutations: {
        SET_REPORTS: (state, payload) => {
            state.reports.conversation = payload.conversation;
            state.reports.aggregation = payload.aggregation;
            state.reports.detailed = payload.detailed;
            state.reports.points = payload.points;
        },
    },
    actions: {
        getReports({ commit }, payload) {
            return Promise.all([
                getAggregationReports(
                    payload.perPage,
                    payload.page,
                    payload.startDate,
                    payload.endDate,
                    payload.userIds
                ),
                getConversationReports(
                    payload.perPage,
                    payload.page,
                    payload.startDate,
                    payload.endDate,
                    payload.userIds
                ),
                getDetailedReports(payload.perPage, payload.page, payload.startDate, payload.endDate, payload.userIds),
            ]).then((responses) => {
                commit("SET_REPORTS", {
                    aggregation: responses[0].data.data,
                    conversation: responses[1].data.data,
                    detailed: responses[2].data.data,
                });
            });
        },
        getPointReports({ commit }, payload) {
            getPointReports(payload.perPage, payload.page, payload.startDate, payload.endDate, payload.userIds).then(
                (response) => {
                    commit("SET_REPORTS", {
                        points: response.data.data,
                    });
                }
            );
        },
    },
};

export default report;
